<template>
  <div
    class="map-list"
  >
    <div class="map-list__body">
      <div class="map-list__head">
        LG Information Display Case Study : {{ subTitle }}
        <div class="map-list__banner">
          <img
            :src="`/theme/rbFront/img/w/case-study/mobile/listBanner/${banner.image}`"
            class="map-list__banner-image"
            alt=""
          >
          <a
            class="map-list__banner-anchor"
            @click="handleClickBanner"
          >
            Learn More >
          </a>
        </div>
      </div>
      <div class="map-list__content">
        <div class="map-list__selectbox">
          <select
            v-model="currentRegin"
            class="map-list__select"
            @change="$emit('change:region', currentRegin)"
          >
            <template v-for="option in items">
              <option
                v-if="filterRegionList(option)"
                :key="option.code"
                :value="option.code"
                class="map-list__select-item"
              >
                {{ option.name }}
              </option>
            </template>
          </select>
        </div>
        <ul class="map-list__list">
          <template v-for="item in currentItems">
            <li
              v-if="filterItem(item)"
              :key="item.id"
              class="map-list__list-item"
            >
              <div class="map-list__vertical">
                {{ item.vertical }}
              </div>
              <div class="map-list__title">
                {{ item.title }}
              </div>
              <div class="map-list__thumbnail">
                <a
                  class="map-list__thumbnail-anchor"
                  @click="$emit('click:video', item)"
                >
                  <img
                    :src="`${imagesHost}${item.thumbnailImage}`"
                    class="map-list__thumbnail-image"
                    alt=""
                  >
                  <img
                    v-if="item.videoUrl"
                    src="~@/assets/img/icon_video.png"
                    class="map-list__thumbnail-icon-video"
                    alt=""
                  >
                  <span class="map-list__vertical-icon">
                    <img
                      v-if="item.vertical === 'Corporate'"
                      src="~@/assets/img/icon_corporate.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Education'"
                      src="~@/assets/img/icon_education.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'General'"
                      src="~@/assets/img/icon_general.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Government'"
                      src="~@/assets/img/icon_government.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Hospitality'"
                      src="~@/assets/img/icon_hospitality.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Public Space'"
                      src="~@/assets/img/icon_public-space.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Retail'"
                      src="~@/assets/img/icon_retail.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Transportation'"
                      src="~@/assets/img/icon_transportation.png"
                      alt=""
                      class="map-list__vertical-icon-image"
                    >
                  </span>
                </a>
              </div>
              <template v-if="item.recommendedProduct.length">
                <div class="map-list__subtitle">
                  Recommended Products
                </div>
                <div class="map-list__recommended">
                  <carousel
                    ref="recommendedProductSlider"
                    :per-page="3"
                    :mouse-drag="true"
                    :navigation-enabled="true"
                    :pagination-enabled="false"
                    class="map-list__recommended-list"
                  >
                    <slide
                      v-for="(product, index) in item.recommendedProduct.filter(p => p.isActive === 'ACTIVE')"
                      :key="`popup__recommended-${index}`"
                      class="map-list__recommended-item"
                    >
                      <a
                        class="map-list__recommended-anchor"
                        @click="handleClickProductDetailLink(product.detailLink, product.prodThumb, product.modelName, product.productCategory1, product.productCategory2, product.productCategory3)"
                      >
                        <img
                          :src="`${imagesHost}${product.prodThumb}`"
                          class="map-list__recommended-thumbnail"
                        >
                        <div class="map-list__recommended-product">{{ product.modelSeries }}</div>
                        <div class="map-list__recommended-modelname">{{ product.modelName }}</div>
                      </a>
                    </slide>
                  </carousel>
                </div>
              </template>
              <div class="map-list__software">
                <a
                  v-if="item.solutionTitle1"
                  :href="item.solutionLink1"
                  class="map-list__software-anchor"
                  target="_blank"
                >
                  {{ item.solutionTitle1 }}
                  <span><img
                    src="/theme/rbFront/img/w/case-study/mobile/arrow_right.png"
                    alt=""
                  ></span>
                </a>
                <a
                  v-if="item.solutionTitle2"
                  :href="item.solutionLink2"
                  class="map-list__software-anchor"
                  target="_blank"
                >
                  {{ item.solutionTitle2 }}
                  <span><img
                    src="/theme/rbFront/img/w/case-study/mobile/arrow_right.png"
                    alt=""
                  ></span>
                </a>
              </div>
              <a
                class="map-list__view-detail"
                @click="handleClickDetailLink(item.detailLink, item.title)"
              >View Detail ></a>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'List',
  components: {
    Carousel,
    Slide
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    region: {
      type: String,
      required: true,
    },
    regionName: {
      type: String,
      required: false,
      default: ''
    },
    viewMode: {
      type: String,
      required: true,
    },
    vertical: {
      type: Object,
      required: true,
    },
    productCategory: {
      type: Object,
      required: true,
    },
    ga4Text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentRegin: '',
      currentItems: [],
      mountedSelf: false
    }
  },
  computed: {
    imagesHost() {
      if (window.location.host.indexOf('www.') > -1) {
        return 'https://image.lgcommercialdisplay.com'
      } else {
        return 'https://stg.lgcommercialdisplay.com'
      }
    },
    subTitle() {
      if (this.viewMode === 'region' || this.viewMode === 'product') {
        let tempText = ''
        this.items.forEach(region => {
          if (region.code === this.currentRegin) {
            tempText = region.name
          }
        })
        return tempText
      } else {
        return this.vertical.name
      }
    },
    banner() {
      if (this.viewMode === 'region' || this.viewMode === 'product') {
        return {
          image: 'Virtual-showroom-tour-experience-virtual-showroom-tour.jpg',
          link: 'https://www.lgcommercialdisplay.com/dc/vertical_category/'
        }
      } else {
        return {
          image: this.vertical.listBanner,
          link: this.vertical.url
        }
      }
    }
  },
  watch: {
    region: {
      immediate: true,
      handler(value) {
        this.currentRegin = value
      }
    },
    currentRegin: {
      immediate: true,
      handler() {
        this.items.forEach((item) => {
          if (item.code === this.currentRegin) {
            this.currentItems = item.items
          }
        })
      }
    },
  }, 
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        if (this.$refs.recommendedProductSlider.length) {
          this.$refs.recommendedProductSlider.forEach((slider) => {
            slider.$el.style.display = 'none';
            slider.$el.offsetHeight; // Accessing this property forces a reflow
            slider.$el.style.display = '';
          });
        }
    });
    }, 1000)
  },
  methods: {
    filterItem(item) {
      if (this.viewMode === 'region' || (this.viewMode === 'vertical' && item.vertical === this.vertical.name)) {
        return true
      } else if(this.viewMode === 'product') {
        let hasProductCategoryCount = 0
        item.recommendedProduct.forEach(prd => {
          if (prd.productCategory1 === this.productCategory.name) {
            hasProductCategoryCount++;
          }
        })
        return hasProductCategoryCount ? true : false
      } else {
        return false
      }
    },
    filterRegionList(region) {
      if (this.viewMode === 'vertical') {
        let hasVerticalCount = 0
        region.items.forEach((item) => {
          if (item.vertical === this.vertical.name) {
            hasVerticalCount++
          }
        })
        if (hasVerticalCount) {
          return true
        } else {
          return false
        }
      } else if(this.viewMode === 'product') {
        let hasProductCategoryCount = 0
        region.items.forEach(item => {
          item.recommendedProduct.forEach(prd => {
            if (prd.productCategory1 === this.productCategory.name) {
              hasProductCategoryCount++;
            }
          })
        })
        return hasProductCategoryCount ? true : false
      } else {
        return true
      }
    },
    handleClickDetailLink(url, text) {
      window.dataLayer.push({
        event: 'select_story',
        click_text: text, 
        click_url: url
      });
      window.open(url, '_blank')
    },
    handleClickProductDetailLink(url, img, name, category1, category2, category3) {
      window.dataLayer.push({
        event: 'select_product',
        click_text: 'View Detail',
        click_url: url,
        img_url: img,
        img_alt: '',
        product_name: name,
        product_category1: category1,
        product_category2: category2,
        product_category3: category3
      });
      window.open(url, '_blank')
    },
    handleClickBanner() {
      window.dataLayer.push({
        event: 'showroom_entrance',
        click_text: this.ga4Text,
        click_url: this.banner.link
      });
      window.open(this.banner.link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
$map-list: '.map-list';
#{$map-list} {
  width: 100%;
  box-sizing: border-box;

  &__body {
    position: relative;
    z-index: 1;
    background-color: #fff;
    height: 100%;
  }
  &__head {
    position: relative;
    padding: 40px 40px 0 33px;
    font-size: calc(32px * 0.67);
    line-height: calc(30px * 0.67);
    font-weight: 400;
  }
  &__banner {
    position: relative;
    margin-top: calc(((20 / 720) * 100) * 1vw);
  }
  &__banner-image {
    max-width: 100%;
  }
  &__banner-anchor {
    position: absolute;
    width: calc(211px * 0.7);
    height: calc(45px * 0.7);
    border-radius: 25px;
    line-height: calc(48px * 0.7);
    font-size: 15px;
    background-color: #fd312e;
    color: #fff;
    text-align: center;
    left: calc(((20 / 720) * 100) * 1vw);
    bottom: calc(((20 / 720) * 100) * 1vw);
    cursor: pointer;
  }
  &__space {
    height: 1px;
    margin-top: 40px;
    background-color: #fff;
    border-bottom: 1px solid #bfbfbf;
    position: relative;
    z-index: 100;
  }
  
  &__content {
    box-sizing: border-box;
    padding: 20px 35px 120px;
  }
  &__selectbox {
    padding: 10px 0 14px;
  }
  &__select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    font-size: 16px;
    line-height: 1.5;
    color: #444;
    background-color: #fff;
    padding: 8px 44px 8px 10px;
    margin: 0;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    background: url(~@/assets/img/arrow_down.png) 104% 18px no-repeat;
  }
  &__list-item {
    padding: 35px 0;
    border-bottom: solid 1px #bfbfbf;
    transform: translateZ(0);
  }
  &__list-item:first-child {
    padding-top: 10px;
  }
  &__list-item:last-child {
    border-bottom: 0;
    padding-bottom: 30px;
  }
  &__thumbnail {
    position: relative;
  }
  &__thumbnail-anchor {
    display: block;
    width: 100%;
    height: 100%;
    font-size: 0;
  }
  &__thumbnail-anchor:hover {
    cursor: pointer;
  }
  &__thumbnail-image {
    width: 100%;
  }
  &__thumbnail-icon-video {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  &__vertical-icon {
    display: block;
    width: 54px;
    height: 50px;
    position: absolute;
    right: 0;
    bottom: 0px;
    background-color: #fff;
  }
  &__vertical-icon-image {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    height: 100%;
  }
  &__vertical {
    font-size: calc(((28 / 720) * 100) * 1vw);
    line-height: calc(((38 / 720) * 100) * 1vw);
    color: #221d1d;
    margin-bottom: 8px;
  }
  &__title {
    font-size: calc(48px * 0.67);
    line-height: calc(50px * 0.67);
    margin-bottom: 20px;
    font-weight: 300;
    color: #221d1d;
  }
  &__subtitle {
    font-size: calc(28px * 0.67);
    line-height: calc(28px * 0.67);
    color: #221d1d;
    margin-top: calc(44px * 0.67);
    margin-bottom: calc(20px * 0.67);
  }
  &__software {
    margin-top: calc(28px * 0.67);
    font-size: calc(26px * 0.67);
  }
  &__software-anchor {
    position: relative;
    display: block;
    height: calc(48px * 0.67);
    line-height: calc(48px * 0.67);
    border: solid 1px #000;
    border-radius: 3px;
    padding: 0 calc(14px * 0.67);
    margin-top: calc(14px * 0.67);

    span {
      position: absolute;
      display: block;
      width: calc(18px * 0.67);
      top: 50%;
      right: calc(15px * 0.67);
      transform: translateY(-50%);
      img {
        max-width: 100%;
      }
    }
  }
  &__software-anchor:first-child {
    margin-top: 0;
  }
  &__view-detail {
    display: block;
    font-size: calc(24px * 0.67);
    color: #000;
    border: 1px solid #000;
    border-radius: 25px;
    height: calc(46px * 0.67);
    line-height: calc(46px * 0.67);
    text-align: center;
    margin-top: calc(26px * 0.67);
  }
  &__recommended-item {
    position: relative;
    min-height: 112px;
    box-sizing: border-box;
  }
  &__recommended-anchor {
    width: calc(((186 / 720) * 100) * 1vw);
    height: 100%;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    display: block;
    border: solid 1px #2d2d2d;
    border-radius: 3px;
    text-align: center;
    box-sizing: border-box;
    padding: 8px 8px 15px;
  }
  &__recommended-item:first-child{
    #{$map-list} {
      &__recommended-anchor {
        margin-left: 0;
      }
    }
  }
  &__recommended-thumbnail {
    max-width: 90px;
    height: 50px;
  }
  &__recommended-product {
    font-size: calc(((18 / 720) * 100) * 1vw);
    line-height: 11px;
    color: #221815;
    margin-bottom: 6px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width: calc(((120 / 720) * 100) * 1vw);
  }
  &__recommended-modelname {
    font-size: calc(((30 / 720) * 100) * 1vw);
    line-height: 20px;
    color: #221815;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width: calc(((146 / 720) * 100) * 1vw);
  }
  /deep/ .VueCarousel-navigation-prev {
    padding: 0!important;
    margin: 0!important;
    width: 15px;
    height: 25px;
    top: 38px;
    left: -25px;
    transform: translateY(0%);
    text-indent: -9999px;
    background: url(~@/assets/img/icon_prevafter15x25.png) 0 0 no-repeat;
  }
  /deep/ .VueCarousel-navigation-next {
    padding: 0!important;
    margin: 0!important;
    width: 15px;
    height: 25px;
    top: 38px;
    right: -25px;
    transform: translateY(0%);
    text-indent: -9999px;
    background: url(~@/assets/img/icon_prevafter15x25.png) 0 100% no-repeat;
  }
}


</style>
